import { useEffect, useState } from "react";
import { Descriptions, Drawer, Image, Tag, Divider } from "antd";
import service from "../../api/FetchInterceptor";

const ShowService = ({ id, open, setOpen }) => {
    const [srv, setSrv] = useState(null);

    const loadService = () => {
        service({
            method: "GET",
            url: `/admin/services/${id}`,
        }).then((response) => {
            const data = response.data ?? response;
            setSrv(data);
        });
    };

    useEffect(() => {
        if (open && id) loadService();
        if (!open) setSrv(null);
    }, [open, id]);

    const boolTag = (val) => (val ? <Tag color="green">Oui</Tag> : <Tag color="red">Non</Tag>);

    // Map prices by length_key
    const pricesMap = (srv?.prices || []).reduce((acc, p) => {
        if (p.length_key) acc[p.length_key] = p.price;
        return acc;
    }, {});

    return (
        <Drawer
            title="Détails du service"
            open={open}
            onClose={() => setOpen(false)}
            width={750}
        >
            {srv && (
                <>
                    {srv.image_path ? (
                        <div style={{ marginBottom: 16 }}>
                            <Image
                                src={srv.image_path}
                                alt={srv.title}
                                width={220}
                                style={{ borderRadius: 12 }}
                            />
                        </div>
                    ) : null}

                    <Descriptions layout="vertical" bordered>
                        <Descriptions.Item label="Groupe" span={3}>
                            {srv.group}
                        </Descriptions.Item>

                        <Descriptions.Item label="Titre" span={3}>
                            {srv.title}
                        </Descriptions.Item>

                        <Descriptions.Item label="Slug" span={3}>
                            {srv.slug}
                        </Descriptions.Item>

                        <Descriptions.Item label="Description" span={3}>
                            {srv.description}
                        </Descriptions.Item>

                        <Descriptions.Item label="Durée (min)" span={1}>
                            {srv.duration_min}
                        </Descriptions.Item>

                        <Descriptions.Item label="Prix de base" span={1}>
                            {srv.base_price}
                        </Descriptions.Item>

                        <Descriptions.Item label="Image" span={1}>
                            {srv.image_path ? <Tag color="blue">OK</Tag> : <Tag>—</Tag>}
                        </Descriptions.Item>

                        <Descriptions.Item label="Prix custom" span={1}>
                            {boolTag(!!srv.is_custom_price)}
                        </Descriptions.Item>

                        <Descriptions.Item label="Prix par longueur" span={1}>
                            {boolTag(!!srv.has_length)}
                        </Descriptions.Item>

                        <Descriptions.Item label="Dépose 3D" span={1}>
                            {boolTag(!!srv.has_3d_removal_choice)}
                        </Descriptions.Item>

                        <Descriptions.Item label="Pose extérieure" span={3}>
                            {boolTag(!!srv.has_outside_set_choice)}
                        </Descriptions.Item>
                    </Descriptions>

                    <Divider />

                    {/* Lengths + prices */}
                    {srv.has_length ? (
                        <>
                            <h4 style={{ marginBottom: 8 }}>Longueurs & Prix</h4>

                            {(srv.lengths || []).length ? (
                                <Descriptions layout="vertical" bordered size="small">
                                    {(srv.lengths || []).map((l) => (
                                        <Descriptions.Item
                                            key={l.id || l.key}
                                            label={`${l.label} (${l.key})`}
                                            span={1}
                                        >
                                            {pricesMap[l.key] ?? "—"}
                                        </Descriptions.Item>
                                    ))}
                                </Descriptions>
                            ) : (
                                <Tag>Pas de longueurs</Tag>
                            )}

                            <Divider />
                        </>
                    ) : null}

                    {/* Options */}
                    <h4 style={{ marginBottom: 8 }}>Options</h4>
                    {(srv.options || []).length ? (
                        <Descriptions layout="vertical" bordered size="small">
                            {(srv.options || []).map((o) => (
                                <Descriptions.Item
                                    key={o.id}
                                    label={`${o.label} — ${o.type}`}
                                    span={3}
                                >
                                    <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                                        {o.add_price !== null ? <Tag>+{o.add_price}</Tag> : null}
                                        {o.min_price !== null ? <Tag>Min: {o.min_price}</Tag> : null}
                                        {o.max_price !== null ? <Tag>Max: {o.max_price}</Tag> : null}
                                        <Tag>+{o.add_duration_min ?? 0} min</Tag>
                                        {o.is_active ? <Tag color="green">Actif</Tag> : <Tag color="red">Inactif</Tag>}
                                        <Tag>Ordre: {o.sort_order}</Tag>
                                    </div>
                                </Descriptions.Item>
                            ))}
                        </Descriptions>
                    ) : (
                        <Tag>Pas d’options</Tag>
                    )}
                </>
            )}
        </Drawer>
    );
};

export default ShowService;
